import { useEffect, useState } from "react"
import { useQuery } from "react-query";
import Login from "../../../assets/components/login/Login";
import client from "../../../assets/service/client";
import useStore from "../../../store/store";

import Loader from '../../../assets/components/loader/Loader';

import {
    ListContainer,
    Wrapper,
    Image,
    Description,
    Title,
    Date
} from './styles'

const Tickets = ()=> {
    const user = useStore(state => state.user);

    const getUserTickets = async () => {
        return await client.get(`/user/${user.id}/tickets`)
        .then(res => {
            return(res.data.tickets)
        })
        .catch(err => err.message)
    }

    const { isLoading, isError, data: tickets, error } = useQuery('userTickets', getUserTickets, {enabled: !!user});

    return (
        !user ? <Login /> :
        <ListContainer>
            { 
                isLoading ? <Loader /> :
                tickets && tickets.length ?
                <>
                    { tickets.map(ticket => {
                        let link = `/wallet/tickets/${ticket.id.toString()}`;
                        let imgKey = ticket.event.backgroundArtImage.key;
                        return (
                            <Wrapper to={link} key={ticket.id}>
                                <Image img={`${process.env.REACT_APP_S3_URL}/${imgKey}`} />
                                <Description>
                                    <Title>{ticket.event.name}</Title>
                                    {ticket.hasOrder && <>Anunciado ~ R$ {ticket.orderPrice}</>}
                                </Description>
                            </Wrapper>
                        )
                    }) }
                    <div style={{textAlign: 'center', "width": '80%', margin: "40px 0"}}>
                        <span>Clique <a target="_blank" href="https://linktr.ee/z_summit_whatsapp">aqui</a> para acessar os nossos grupos de whatsapp</span>
                    </div>
                </>
                :
                <>
                    <div style={{height: "2em"}} />
                    <span style={{fontSize: "1.2em", color: "gray"}}>Você ainda não possui nenhum ingresso</span>
                    <div style={{height: "2em"}} />
                    <div style={{
                        height: '200px',
                        width: '80%',
                        maxWidth: "350px",
                        backgroundImage: "url('https://i.kym-cdn.com/photos/images/original/001/042/619/4ea.jpg')",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        borderRadius: "15px"
                    }} />
                </>
            }
        </ListContainer>
    )
}

export default Tickets